var map = {
	"./Acc-1.jpg": "f414",
	"./Acc-2.jpg": "7f3d",
	"./Acc-3.jpg": "68f5",
	"./Acc-4.png": "2cb7",
	"./Acc-5.png": "e17f",
	"./hero-acc.jpg": "cc3c",
	"./hero-contact.jpg": "cdd7",
	"./hero-inst.jpg": "6fff",
	"./hero-pm.png": "97e7",
	"./hero-transformer.jpg": "0a9c",
	"./inst-electrical.jpg": "d185",
	"./inst-solar.jpg": "11fe",
	"./inst-transformer1.jpg": "c659",
	"./transformer-industrial.jpg": "42cc",
	"./transformer-pole.jpg": "ba56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";